import type { RequestParams } from '@/shared/api';
import type { AgentGeoZoneItemListParams } from '../model/types';

export const AGENT_GEO_ZONE_KEYS = {
  all: ['agent-geo-zone'] as const,
  list: (params?: RequestParams) => [...AGENT_GEO_ZONE_KEYS.all, 'list', params] as const,
  polygonList: () => [...AGENT_GEO_ZONE_KEYS.all, 'polygon-list'] as const,
  detail: (id: number) => [...AGENT_GEO_ZONE_KEYS.all, 'detail', id] as const,
  itemList: (params?: AgentGeoZoneItemListParams) => [...AGENT_GEO_ZONE_KEYS.all, 'item-list', params] as const,
};
